export default __webpack_public_path__ + "static/media/Vector1.6894ae9f.svg";